import React, { useCallback } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { Text } from 'react-native';
import { Type } from '@/components/toast';
import { useToasts } from '@/contexts/toast-context';

interface ToastCallbacks {
  showErrorToast: (copy: string) => void;
  showSuccessToast: (copy: string) => void;
}

export const useOfflineModeStyledToasts = (): ToastCallbacks => {
  const [styles] = useStyles();
  const { showToast } = useToasts();
  const showSuccessToast = useCallback(
    (copy: string) => {
      showToast({
        containerStyle: styles.toastContainer,
        content: <Text style={styles.toastText}>{copy}</Text>,
        showCloseButton: false,
        type: Type.MINIMAL,
      });
    },
    [showToast, styles.toastContainer, styles.toastText],
  );
  const showErrorToast = useCallback(
    (copy: string) => {
      showToast({
        containerStyle: styles.toastContainerError,
        content: <Text style={styles.toastTextError}>{copy}</Text>,
        showCloseButton: false,
        type: Type.MINIMAL,
      });
    },
    [showToast, styles.toastContainerError, styles.toastTextError],
  );

  return { showErrorToast, showSuccessToast };
};

const useStyles = createStyles((theme) => ({
  toastContainer: {
    backgroundColor: theme.colors.white,
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  toastContainerError: {
    backgroundColor: theme.colors.negative,
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  toastText: {
    ...FONTS.primary,
    color: theme.colors.primary,
    fontSize: 14,
  },
  toastTextError: {
    ...FONTS.primary,
    color: theme.colors.white,
    fontSize: 14,
    fontWeight: '600',
  },
}));
